import React from 'react';
import { BUTTON_TYPES } from 'common/types/forms';
const Button = ({ children, type, isFullWidth = false, disabled = false, className, onCLick, icon, target, href = null }) => {
    let cssType;
    switch (type) {
        case BUTTON_TYPES.BUTTON_LINK:
            cssType = 'btn-link cm-btn__link';
            break;
        case BUTTON_TYPES.BUTTON_POPUP:
            cssType = 'btn-primary cm-btn__popup';
            break;
        case BUTTON_TYPES.BUTTON_SECONDARY:
            cssType = 'btn-outline-primary cm-btn__secondary';
            break;
        case BUTTON_TYPES.BUTTON_SECONDARY_CMP:
            cssType = 'btn-outline-primary cm-btn__secondary-cmp';
            break;
        case BUTTON_TYPES.BUTTON_PRIMARY_CMP:
            cssType = 'cm-btn--cmp';
            break;
        case BUTTON_TYPES.BUTTON_PRIMARY_SMALL:
            cssType = 'btn-primary cm-btn__primary-small';
            break;
        default:
            cssType = 'btn-primary';
    }
    return href ? (React.createElement("a", { className: `cm-btn btn ${isFullWidth ? 'cm-btn__full-width' : ''} ${cssType} ${className} ${disabled ? 'disabled' : ''}`, href: href, target: target },
        icon && icon,
        children)) : (React.createElement("button", { className: `cm-btn btn ${isFullWidth ? 'cm-btn__full-width' : ''} ${cssType} ${className}`, disabled: disabled, onClick: onCLick },
        icon && icon,
        children));
};
export default Button;
